fragment GlobalContactInformation on generalInformation_Entry {
    id
    email
    phoneNumber
}